import { AreaChart } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgChartArea = mkIcon(AreaChart);